import { useData } from "./DataContext.js";

import Markdown from "react-markdown";
import Button from "react-bootstrap/Button";

export default function CourseCardStep (props)
{
    const gData = useData();

    const documentList = props.step.documents === undefined ? [] :
			 props.step.documents.map((document, index) => {
			     function handleClick () { window.open(document.url, "_blank").focus(); }
			     return (<Button key={index} variant="primary" size="sm" onClick={handleClick}>{document.title}</Button>)
			 });

    const button = props.step.button === undefined ? null : props.step.button;

    function handleStart ()
    {
	const adminCodes = Object
	    .entries(gData.group)
	    .filter(([id, group]) => { return group.simID === gData.simID && group.type === "admin"; })
	    .map(([id, group]) => group.code);
	const url = "#/play?code="+adminCodes[0];
	window.open(url, "_blank").focus();
    }
    
    return (
	<div>
	    <div className="text-uppercase text-muted">{props.step.title}</div>
	    <div className=""><Markdown>{props.step.content}</Markdown></div>
	    {documentList.length > 0 && (<p className="d-flex flex-wrap gap-2 mt-2">{documentList}</p>)}
	    {button === "start" && (
		<p className="w-100 text-center">
		    <Button variant="primary" onClick={handleStart}>Accéder à la simulation</Button>
		</p>
	    )}
	</div>
    );
}
